import { useState, useRef, useEffect } from "react";

export const MyAccount = ()=> {

    const [isMyAccountVisible, setIsMyAccountVisible ] = useState(false);
    const [isLogged, setIsLogged ] = useState(true);
    const [isOpenAccountInfo, setIsOpenAccountInfo ] = useState(false);
    const btnToggleMyAccount = useRef(null);
    const userRef = useRef(null);


    const toggleMyAccountVisibility = () => {
        setIsMyAccountVisible(!isMyAccountVisible);
    }

    const toggleAccountContainer = () => {
        setIsOpenAccountInfo(!isOpenAccountInfo);
    } 

    const handleClickOutside = (event) => {
        if (!userRef.current.contains(event.target) && !btnToggleMyAccount.current.contains(event.target)) {
          setIsMyAccountVisible(false);
        }
      };

    useEffect(() => {
        if (isMyAccountVisible) {
          document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [isMyAccountVisible]);

    return (
            <>{isLogged && (
                <button className="redcoach-btn-customer" onClick={toggleMyAccountVisibility} ref={btnToggleMyAccount} type="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="radix-:r1v:">
                    <div className="redcoach-icon-customer">
                        <span>RP</span>
                    </div>
                </button>
                )}
                {isMyAccountVisible && (
                    <div ref={userRef} className="redcoach-container-my-account">
                        <div className="redcoach-container-customer-data">
                            <div className="redcoach-container-name-customer">
                                <div className="redcoach-customer-name">
                                    <h2>Hi, Nicole!</h2>
                                    <button>RedRider</button>
                                </div>
                                <div>
                                    <span>CP240226624644</span>
                                </div>
                            </div>
                            <div className="redcoach-container-points">
                                <div className="redcoach-total-points">
                                    <span>112</span>
                                    <span>Total points</span>
                                </div>
                                <div className="redcoach-separator"></div>
                                <div className="redcoach-active-points">
                                    <span>12</span>
                                    <span>Active Points</span>
                                </div>
                                <div className="redcoach-separator"></div>
                                <div className="redcoach-voucher-balance">
                                    <span>$10.00</span>
                                    <span>Voucher Balance</span>
                                </div>
                            </div>
                            <div className="redcoach-btn-to-dashboard">
                                <button>My Loyalty Dashboard</button>
                            </div>
                        </div>
                        <div className="redcoach-container-info-my-account">
                            <div className={`redcoach-accordion-account ${isOpenAccountInfo ? 'open' : ''}`}>
                                <button onClick={toggleAccountContainer}>
                                    <span>Account</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M19 9L12 15L5 9" stroke="#616972" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                            <div className={`redcoach-container-toggle-account ${isOpenAccountInfo ? 'open' : ''}`}>
                                <div className="redcoach-container-account">
                                    <div>Account information</div>
                                    <div>Password and Safety</div>
                                    <div>Payment methods</div>
                                </div>
                            </div>
                            <div>
                                <span>Vouchers</span>
                            </div>
                            <div>
                                <span>My trips</span>
                            </div>
                            <div>
                                <button className="redcoach-btn-log-out">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                        <path d="M6.00128 5.16671C6.00935 3.71669 6.07365 2.93142 6.58591 2.41916C7.1717 1.83337 8.11451 1.83337 10.0001 1.83337L10.6668 1.83337C12.5524 1.83337 13.4952 1.83337 14.081 2.41916C14.6668 3.00495 14.6668 3.94776 14.6668 5.83337L14.6668 11.1667C14.6668 13.0523 14.6668 13.9951 14.081 14.5809C13.4952 15.1667 12.5524 15.1667 10.6668 15.1667L10.0001 15.1667C8.1145 15.1667 7.1717 15.1667 6.58591 14.5809C6.07365 14.0687 6.00935 13.2834 6.00128 11.8334" stroke="#616972" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M10 8.5L1.33333 8.5M1.33333 8.5L3.66667 6.5M1.33333 8.5L3.66667 10.5" stroke="#616972" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span>Log out</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    )
                }
            </>
        ); 
}